import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useRoutes } from './routes';

// a hook that any component can call to find out which route is currently active
export const useSelectedRoute = () => {
  const location = useLocation(); // from react router, gives current URL

  const { routes } = useRoutes(); // the list from routes.tsx

  // loops through all routers and returns the first one
  // whose path matches the current URL
  const selectedRoute = useMemo(() => {
    for (const route of routes) {
      if (
        route.path !== '' &&
        route.path !== '/' &&
        location.pathname.indexOf(route.path) > -1
      ) {
        return route;
      }
    }
  }, [location, routes]);

  return selectedRoute;
};
